import { handleSlider } from '@/scripts/optional/latest-pvolve'

document.addEventListener('DOMContentLoaded', () => {
	handleSlider();
})